import React from "react";

export default function LeavePagination({
  currentPage,
  totalPages,
  handlePageChange,
  goToPreviousPage,
  goToNextPage,
  searchQuery,
  filteredData,
}) {
  return (
    <div>
      {!searchQuery && filteredData.length > 0 && (
        <div className="pagination">
          <div>
            <button onClick={goToPreviousPage} disabled={currentPage === 1}>
              <i className="fa-solid fa-arrow-left-long"></i> Previous
            </button>
          </div>
          <div>
            {Array.from({ length: totalPages }, (_, index) => {
              const startPage = currentPage - 5 > 0 ? currentPage - 5 : 1;
              const endPage =
                startPage + 9 < totalPages ? startPage + 9 : totalPages;
              return (
                index + 1 >= startPage &&
                index + 1 <= endPage && (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    className={currentPage === index + 1 ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                )
              );
            })}
          </div>
          <div>
            <button onClick={goToNextPage} disabled={currentPage >= totalPages}>
              Next <i className="fa-solid fa-arrow-right-long"></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
